import { NumberFormat } from '@lightspeed/i18n-number-format';
import { Styles } from '@lightspeed/i18n-number-format/types';

export const formatMoney = (value: number, currency: string) => {
  const fmt = new NumberFormat({ locale: window.merchantos.locale.lang || 'en-US' });

  const formatOptions = {
    style: 'currency' as Styles,
    currencyCode: currency,
  };

  return fmt.format(value, formatOptions);
};
